export const DARK_MODE_SETTINGS = {
  initializeWithValue: false,
  localStorageKey: 'darkMode',
};

export const ADSENSE_ID = 'ca-pub-5201956155134669';

export const GTM_ID = 'GTM-5WC42T9';
